// Internal helpers describing how the CDN serves certain file extensions.
export const OCTET_STREAM_EXTENSIONS = new Set(['tgz', 'gz', 'bz2', 'xz', 'zst', 'har']);
export const EXTENSIONS_REQUIRING_FILENAME = new Set(['html', ...OCTET_STREAM_EXTENSIONS]);

/**
 * Whether the browser can't render this extension inline, so opening it should
 * force a download instead. The CDN serves these as the wrong content-type
 * (e.g. `.har` as `application/json`), so linking to them directly saves the
 * file under the wrong name.
 */
export const requiresContentOverride = extension => Boolean(extension && OCTET_STREAM_EXTENSIONS.has(extension));